<template>
    <div>
        <breadcrumb :routerList="[{to:'/agent/weekMeeting',title:'周清会议列表'},{title:'新增周会议纪要'}]"/>

        <div class="h-content">

            <div class="h-row h-mrt0">
                <div class="h-rowIn">

                    <div class="h-rowBox">
                        <el-form  ref="form1" :model="f"  :rules="rules">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增周会议纪要</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine ">

                                            <div class="margin-top el-descriptions">
                                                <div class="el-descriptions__body">
                                                     <table class ="meeting-table el-descriptions__table is-bordered ">
                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">客户基本信息</th>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                 经销商名称
                                                             </th>
                                                             <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item prop="agentName" >
                                                                     <el-input v-model="f.agentName" placeholder="请输入" readonly>
                                                                         <i
                                                                                 v-if="selectDailishang"
                                                                                 class="el-icon-search el-input__icon"
                                                                                 slot="suffix"
                                                                                 @click="openAgent">
                                                                         </i>
                                                                     </el-input>
                                                                 </el-form-item>

                                                             </td>
                                                             <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">签约渠道</th>
                                                             <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item prop="channelCode" >
                                                                     <el-select :multiple="true"
                                                                                :clearable="true"
                                                                                v-model="f.channelCode"
                                                                                :v="f.channelCode"
                                                                                @change="getQudao"
                                                                     >
                                                                         <el-option v-for="item in qudao"
                                                                                    :key="item.index"
                                                                                    :value="item.code"
                                                                                    :label="item.name"
                                                                         ></el-option>
                                                                     </el-select>
                                                                 </el-form-item>
                                                             </td>
                                                             <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">运营会时间（周次）</th>
                                                             <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item prop="weekTime" >
                                                                     <el-select filterable v-model="f.weekTime" clearable  placeholder="请选择"  @change="changeWeek">
                                                                         <el-option
                                                                                 v-for="(item,index) in qweekList"
                                                                                 :key="item.week"
                                                                                 :label="item.weekStr"
                                                                                 :value="item.week">
                                                                         </el-option>
                                                                     </el-select>
                                                                 </el-form-item>
                                                             </td>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">召开人</th>
                                                             <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-input v-model="f.conveneName" placeholder="请输入" readonly></el-input>
                                                             </td>
                                                             <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">参会人</th>
                                                             <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="participants" >
                                                                     <el-input v-model="f.participants"></el-input>
                                                                 </el-form-item>

                                                             </td>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">客户签约目标</th>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="5"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月度履约</th>
                                                             <th colspan="7"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本周进展</th>
                                                         </tr>
                                                         <tr>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月份</th>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月目标</th>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预计达成</th>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">履约率（%）</th>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月累计（万）</th>
                                                             <th rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周预计下单（万）</th>
                                                             <th colspan="6" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周预计下单（万）</th>
                                                         </tr>
                                                         <tr>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">样本网 </th>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">药品网</th>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">云眼网</th>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">培养箱</th>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">离心机</th>
                                                             <th class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">血液/疫苗网</th>
                                                         </tr>
                                                         <tr>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="month" >
                                                                     <template slot-scope="scope">
                                                                         <div style="text-align: right;">
                                                                             {{f.month}}
                                                                         </div>
                                                                     </template>
                                                                  </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="monthTarget" >
                                                                     <template slot-scope="scope">
                                                                         <div style="text-align: right;">
                                                                             {{f.monthTarget }}
                                                                         </div>
                                                                     </template>
                                                                  </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="monthExpect" >
                                                                     <el-input v-model="f.monthExpect"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="completionRate" >
                                                                     <template slot-scope="scope">
                                                                         <div style="text-align: right;">
                                                                             {{f.completionRate }}
                                                                         </div>
                                                                     </template>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="monthTotal" >
                                                                     <template slot-scope="scope">
                                                                         <div style="text-align: right;">
                                                                             {{f.monthTotal }}
                                                                         </div>
                                                                     </template>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpect" >
                                                                     <template slot-scope="scope">
                                                                         <div style="text-align: right;">
                                                                             {{nextWeekExpect }}
                                                                         </div>
                                                                     </template>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectYb" >
                                                                     <el-input v-model="f.nextWeekExpectYb" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectYp" >
                                                                     <el-input v-model="f.nextWeekExpectYp" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectYy" >
                                                                     <el-input v-model="f.nextWeekExpectYy" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectPyx" >
                                                                     <el-input v-model="f.nextWeekExpectPyx" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectLxj" >
                                                                     <el-input v-model="f.nextWeekExpectLxj" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td  class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekExpectUsj" >
                                                                     <el-input v-model="f.nextWeekExpectUsj" type ="number"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">本月重点落地任务</th>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="4"class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">重点落地任务描述 </th>
                                                             <th colspan="4"class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本周进展总结</th>
                                                             <th colspan="4" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">下周计划</th>
                                                         </tr>
                                                         <tr>
                                                             <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="keyTask" >
                                                                     <el-input type="textarea" maxlength="500" show-word-limit v-model="f.keyTask"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="weekProgressSummary" >
                                                                     <el-input type="textarea" maxlength="500" show-word-limit v-model="f.weekProgressSummary"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <td colspan="4" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="nextWeekPlan" >
                                                                     <el-input type="textarea" maxlength="500" show-word-limit v-model="f.nextWeekPlan"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                          </tr>


                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">本周亮点</th>
                                                         </tr>
                                                         <tr>
                                                             <td colspan="12" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="weekHighlight" >
                                                                     <el-input type="textarea" maxlength="500" show-word-limit v-model="f.weekHighlight"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">竞争对手分析</th>
                                                         </tr>
                                                         <tr>
                                                             <td colspan="12" style="height: 80px;" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="competitorAnalysis" >
                                                                     <el-input type="textarea" maxlength="500" show-word-limit v-model="f.competitorAnalysis"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                         </tr>
                                                         <tr>
                                                             <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">协同问题</th>
                                                         </tr>

                                                         <tr>
                                                             <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">链群</th>
                                                             <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item prop="lianqun">
                                                                     <brselect clearable @change="selectLianqun" category="gh_lianqun" v-model="f.lianqun" :v="f.lianqun"></brselect>
                                                                 </el-form-item>
                                                             </td>
                                                             <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">问题分类</th>
                                                             <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="problemType">
                                                                     <brselect clearable @change="selectProblemType" category="xtwt_type" v-model="f.problemType" :v="f.problemType"></brselect>
                                                                 </el-form-item>
                                                             </td>
                                                             <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">影响及紧急程度</th>
                                                             <td   colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="influenceLevel" >
                                                                     <el-input  v-model="f.influenceLevel"></el-input>
                                                                 </el-form-item>
                                                             </td>
                                                             <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">资源需求类型</th>
                                                             <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <el-form-item  prop="problemDeptType" >
                                                                     <el-select clearable @change="selectProblemDeptType" v-model="f.problemDeptType" :v="f.problemDeptType" placeholder="请选择"  >
                                                                         <el-option label="个性问题" value="1"></el-option>
                                                                         <el-option label="共性问题" value="2"></el-option>
                                                                     </el-select>
                                                                 </el-form-item>
                                                             </td>
                                                         </tr>
                                                        <tr>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">要求到位时间</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="endDate" >
                                                                    <el-date-picker
                                                                            :clearable="true"
                                                                            type="date"
                                                                            value-format="yyyy-MM-dd"
                                                                            placeholder="选择时间"
                                                                            v-model="f.endDate"
                                                                            style="width: 100%;"
                                                                    ></el-date-picker>
                                                                </el-form-item>
                                                            </td>

                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">承接部门</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="jobGroup" >
                                                                    <el-select clearable class="h-tableInput" v-model="f.jobGroup" :v="f.jobGroup"
                                                                               placeholder="请选择" style="width: 100%"
                                                                               @change="selectUser">
                                                                        <el-option v-for="(item) in JobGroup"
                                                                                   :key="item.id"
                                                                                   :label="item.jobGroup"
                                                                                   :value="item.jobGroup"
                                                                        >
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">答复人</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">

                                                                <el-form-item  prop="pointUser" >
                                                                    <el-select clearable class="h-tableInput"v-model="f.pointUser"
                                                                               placeholder="请选择" style="width: 100%"
                                                                               @change="getNameCode">
                                                                        <el-option v-for="(item) in PointUser"
                                                                                   :key="item.id"
                                                                                   :label="item.pointUser"
                                                                                   :value="item.pointUser"
                                                                        >
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>

                                                            </td>
                                                            <th  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">协同问题</th>
                                                            <td  colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="dailyQuestion" >
                                                                    <el-input type="textarea" maxlength="500" show-word-limit v-model="f.dailyQuestion"></el-input>
                                                                </el-form-item>
                                                            </td>

                                                        </tr>


                                                         <tr>
                                                             <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">会议照片</th>
                                                             <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                 <brupload
                                                                         :limit="3"
                                                                         :isTp = true
                                                                         :tpFlag = true
                                                                         :refid="refid"
                                                                         reftype="周清会议纪要-会议照片"
                                                                         :uploadflag="true"
                                                                         :delflag="true"
                                                                         :showtime="false">
                                                                 </brupload>
                                                             </td>
                                                             <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                                             </td>
                                                         </tr>

                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>

            <!--售达方-->
            <shoudf
                    :visible.sync="showshdfdialog"
                    v-if="showshdfdialog"
                    @choseObj="choseAgent"
                    oneflag
                    :ddlx="1"
                    title="选择售达方"/>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>

             </div>
        </div>
    </div>
</template>

<script>
    import shoudf from '../../../../components/dialog/selectshdf'
    import weekMeetingService from "../../../../api/loud/weekMeeting/weekMeetingService";
    import moment from "moment";
    import big from "big.js";
    import weekYearMonthService from "../../../../api/loud/weekMeeting/weekYearMonthService";
    import ss from "../../../../api/SystemService";

    export default {

        components: {
            shoudf
        },

        data() {

            return {
                showshdfdialog: false,
                selectDailishang: true,
                qudao:[],
                qudaos:'',
                qweekList :[],
                //承接部门
                JobGroup: [],
                //回复人
                PointUser: [],
                refid:null,
                j:{
                    jobGroup: null,
                },
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    channelCode:null, // 经销商渠道编码
                    channelName:null, // 经销商渠道名称
                    weekTime:null, // 运营会时间-周
                    weekStr:null, //周范围字符串
                    weekMonth:null,//运营会时间-月（该周属于几月份）
                    weekYear:null, // 运营会时间
                    conveneCode:null, // 召开人编码
                    conveneName:null, // 召开人名称
                    participants:null, // 参会人员
                    month:null, // 月份
                    monthTarget:null, // 本月目标
                    monthExpect:null, // 本月预计达成
                    completionRate:null, // 履约率
                    monthTotal:null, // 本月累计（万）
                    nextWeekExpect:null, // 下周预计下单（万）
                    nextWeekExpectYb:0, // 下周预计下单-样本网
                    nextWeekExpectYp:0, // 下周预计下单-药品网
                    nextWeekExpectYy:0, // 下周预计下单-云眼网
                    nextWeekExpectPyx:0, // 下周预计下单-培养箱
                    nextWeekExpectLxj:0, // 下周预计下单-离心机
                    nextWeekExpectUsj:0, // 下周预计下单-血液/疫苗网
                    keyTask:null, // 重点任务描述
                    weekProgressSummary:null, // 本周进展总结
                    nextWeekPlan:null, // 下周计划
                    weekHighlight:null, // 本周亮点
                    competitorAnalysis:null, // 对手分析

                   /* problemDescription:null, // 问题描述
                    collaborator:null, // 协同人
                    arrivalTime:null, // 到位时间*/
                    lianqun:null, // 链群
                    lianqunName:null, // 链群
                    problemType:null, // 提出问题分类
                    problemTypeName:null, // 提出问题分类
                    endDate:null, // 回答时间
                    influenceLevel:null, // 影响及紧急程度
                    problemDeptType:null, // 资源需求类型
                    problemDeptTypeName:null, // 资源需求类型
                    dailyQuestion:null, // 协同问题
                    jobGroup:null, // 承接部门
                    pointUser:null, // 用户名称--用户编码
                    jobUsername:null, // 用户名称
                    jobUsercode:null, // 用户名称
                    areaCode:null,//区域编码

                    score:null, // 评分
                    summarize:null, // 总结
                    fileId:null,
                },
                rules: {
                    agentName: [{required: true, message: '请选择经销商', trigger: 'blur'}],
                    channelCode: [{required: true, message: '请选择签约渠道', trigger: 'blur'}],
                    weekTime: [{required: true, message: '请选择运营会时间（周次）', trigger: 'blur'}],
                    participants: [{required: true, message: '请填写参会人员', trigger: 'blur'}],
                    monthExpect: [{required: true, message: '请填写本月预计目标', trigger: 'blur'}],
                    keyTask: [{required: true, message: '请填写重点落地任务描述', trigger: 'blur'}],
                    weekProgressSummary: [{required: true, message: '请填写本周进展总结', trigger: 'blur'}],
                    nextWeekPlan: [{required: true, message: '请填写下周计划', trigger: 'blur'}],

                },

            }
        },

        created() {
            this.f.conveneCode = this._user.usercode;
            this.f.conveneName = this._user.username;
            this.getqWeeks(new Date().getFullYear(),1);
            this.f.month  = new Date().getMonth()+ 1+"月"; //获取当前月
            this.refid = this.$util.getUuid();
            this.selectJobGroup();

        },
        computed : {
            nextWeekExpect: function () {
                return  new big(this.f.nextWeekExpectYb||0).plus(this.f.nextWeekExpectYp||0).plus(this.f.nextWeekExpectYy||0).plus(this.f.nextWeekExpectPyx||0)
                    .plus(this.f.nextWeekExpectLxj||0).plus(this.f.nextWeekExpectUsj||0).toString();

            },

        },


        methods: {

            //返回
            backS() {
                this.$router.go(-1);
            },
            //选择经销商
            openAgent() {
                this.showshdfdialog = true;
            },
            //选择经销商
            choseAgent(val) {
                this.showshdfdialog = false;

                this.f.agentName = val.username;
                this.f.agentCode = val.usercode;
                this.f.areaCode = val.area;
                this.selectChannel();
                this.f.channelCode = '';
                this.f.channelName = '';

                //获取经销商月目标信息
                weekMeetingService.getMonthTarget(this.f.agentCode).then(response => {
                    this.f.monthTarget = response.monthTarget;
                    this.f.monthTotal = response.monthTotal;
                    this.f.completionRate = response.completionRate;
                })

            },

            //查询渠道
            selectChannel() {
                weekMeetingService.selectChannel(this.f.agentCode).then(response => {
                    this.qudao = response;
                })
            },

            getqWeeks(y,z){
                weekYearMonthService.getWeekList({year:y}).then(rd => {
                    this.qweekList = rd;
                    this.getKnowWeek();
                })
            },
            getKnowWeek() {
                var week1 = this.getWeekNum();
                this.qweekList.forEach(element => {
                    if(week1 == element.week){
                        this.f.weekTime = element.week;//第几周
                        this.f.weekStr = element.weekStr;//周范围字符串
                        this.f.weekMonth = element.month;//该周属于几月份
                        this.f.weekYear =element.year;//改周属于哪一年
                    }
                });
            },
            //选择周更新年月
            changeWeek(week){
                this.qweekList.forEach(element => {
                    if(week == element.week){
                        this.f.weekStr = element.weekStr;//周范围字符串
                        this.f.weekMonth = element.month;//该周属于几月份
                        this.f.weekYear = element.year;//改周属于哪一年
                    }
                });
            },
            //获得当前日期是第几周的方法
            getWeekNum() {
                var year = new Date().getFullYear();
                var week = moment(new Date()).format("E");//获得今天是星期几
                console.log("week",week)
                var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
                //今天到1月1号的时间戳之差
                var millisDiff =
                    new Date(moment().format("yyyy-MM-DD")).getTime() -
                    new Date(year + "-01-01").getTime();
                var days =
                    (millisDiff -
                        week * (24 * 60 * 60 * 1000) -
                        (7 - startweek) * (24 * 60 * 60 * 1000)) /
                    86400000;
                return days / 7 + 1;
                //这里加的2代表的是本周和今年1月1号所在的那一周
            },
            getQudao(value){
                var jsonObj = value
                var jStr = '';
                for(var item in jsonObj){
                    jStr += jsonObj[item]+",";
                }
                this.channels = jStr.substring(0, jStr.lastIndexOf(','))
             },

            //提交
            submit() {

                var subflag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });

                //校验协同问题（若填写 全必填）
                if(this.f.lianqun || this.f.lianqunName || this.f.problemType || this.f.problemTypeName || this.f.influenceLevel || this.f.problemDeptType || this.f.problemDeptTypeName || this.f.endDate || this.f.jobGroup || this.f.jobUsername || this.f.jobUsercode || this.f.dailyQuestion){
                    if(!this.f.lianqun || !this.f.lianqunName || !this.f.problemType || !this.f.problemTypeName || !this.f.influenceLevel || !this.f.problemDeptType || !this.f.problemDeptTypeName || !this.f.endDate || !this.f.jobGroup || !this.f.jobUsername || !this.f.jobUsercode || !this.f.dailyQuestion){
                        this.$msg.msge("请将协同问题信息填写完整！");
                        return false;
                    }
                }


                if (subflag == true) {
                    this.$msg.confirm("确认提交该信息?", () => {

                        //获取选中的渠道对象list
                        let channel = _.filter(this.qudao,(o)=>{
                            return _.includes( this.f.channelCode,o.code)

                        })
                         //将选中的渠道编码与名称匹配
                        let channelNames='';
                        for(var item in channel){
                            channelNames += channel[item].name+",";
                        }
                        channelNames = channelNames.substring(0, channelNames.lastIndexOf(','))

                        this.f.channelName = channelNames;
                        this.f.channelCode = this.channels;

                        this.f.nextWeekExpect = this.nextWeekExpect;
                        //设置附件id
                        this.f.fileId  = this.refid

                        weekMeetingService.insert(this.f).then(rd=>{
                            this.$router.push({path: "/agent/weekMeeting"});
                        })
                    });
                }

            },
            //选择链群
            selectLianqun(value){
               if(value){
                   this.f.lianqun = value.code;
                   this.f.lianqunName = value.name;
               }else{
                   this.f.lianqun = null;
                   this.f.lianqunName = null;
               }


            },
            //问题分类
            selectProblemType(value){
                if(value){
                    this.f.problemType = value.code;
                    this.f.problemTypeName = value.name;
                }else{
                    this.f.problemType = null;
                    this.f.problemTypeName = null;
                }


            },
            //选择资源需求类型
            selectProblemDeptType(value){
                if(value==1){
                    this.f.problemDeptTypeName ="个性问题";
                }else if(value==2){
                    this.f.problemDeptTypeName ="共性问题";
                }else{
                    this.f.problemDeptTypeName =null;
                }
            },

            //用户名列表
            selectUser(value) {
                this.f.jobGroup = value;
                ss.xietongguanli.selectAnsUser({jobGroup:this.f.jobGroup}).then(rd => {
                    this.PointUser = rd;
                    this.f.pointUser = null;
                    this.f.jobUsername = null;
                    this.f.jobUsercode = null;
                });
            },

            //部门列表
            selectJobGroup() {
                ss.xietongguanli.selectDeptPoint().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //带出用户编码
            getNameCode(pointUser) {
                let [name, code] = pointUser.split("--");
                this.f.jobUsername = name;
                this.f.jobUsercode = code;
            },
        }

    }


</script>
<style scoped lang="scss">
    ::v-deep .meeting-table  th ,td {

         text-align: center!important;
         border: 1px solid #303133!important;
         vertical-align:middle;

     }
    ::v-deep .my-label {
         background: #fff2e5!important;

     }
    ::v-deep .my-label-lab {
         background: #E8F5F8!important;

     }
    ::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
         line-height: 0.25rem;
     }

    ::v-deep .el-form-item {
         margin-bottom: 0 !important;
     }
</style>
